import { useEffect, useState } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import Modal from '../../../components/ui/Modal';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import { getErrorMessage } from '../../../lib/apiClient';
import { renameFile, renameFolder } from '../filesApi';

export default function RenameModal({ open, onClose, target }) {
  const [name, setName] = useState('');
  const queryClient = useQueryClient();

  useEffect(() => {
    if (target) setName(target.item.name);
  }, [target]);

  const mutation = useMutation({
    mutationFn: () => {
      const fn = target.type === 'folder' ? renameFolder : renameFile;
      return fn({ id: target.item.id, name: name.trim() });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['folder-contents'] });
      toast.success('Renamed');
      onClose();
    },
    onError: (error) => toast.error(getErrorMessage(error, 'Rename failed')),
  });

  if (!target) return null;

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={`Rename ${target.type}`}
      footer={
        <>
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button
            onClick={() => mutation.mutate()}
            loading={mutation.isPending}
            disabled={!name.trim() || name.trim() === target.item.name}
          >
            Save
          </Button>
        </>
      }
    >
      <Input
        label="New name"
        value={name}
        autoFocus
        onChange={(e) => setName(e.target.value)}
        onKeyDown={(e) => e.key === 'Enter' && name.trim() && mutation.mutate()}
      />
    </Modal>
  );
}
